'use client';

import { Skeleton } from '@wwe-portal/ui/components/skeleton';

import dynamicLoad from 'next/dynamic';

export const RosterFilterSectionWithLocalLazy = dynamicLoad(
  async () =>
    import('./roster-filter-section-with-local').then(
      (mod) => mod.RosterFilterSectionWithLocal
    ),
  {
    ssr: false,
    loading: () => (
      <div className="flex w-full items-center justify-center">
        <Skeleton className="h-10 w-full max-w-[426px]" />
      </div>
    ),
  }
);
